import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/$owner/agents/$agentId/guardrails")({
	component: AgentGuardrailsLayout,
});

function AgentGuardrailsLayout() {
	return <Outlet />;
}
